export default {"src":"/_next/static/media/facebook.b25bde7a.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};